function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { renderless as renderless$3, api as api$3 } from "@opentiny/vue-renderless/tabs-mf/vue";
import { defineComponent, $props, setup as _setup, h, props } from "@opentiny/vue-common";
import { renderless as renderless$2, api as api$2 } from "@opentiny/vue-renderless/tabs-mf/vue-bar";
import { IconClose, IconPopup, IconPlus } from "@opentiny/vue-icon";
import Dropdown from "@opentiny/vue-dropdown";
import DropdownMenu from "@opentiny/vue-dropdown-menu";
import DropdownItem from "@opentiny/vue-dropdown-item";
import { renderless as renderless$1, api as api$1 } from "@opentiny/vue-renderless/tabs-mf/vue-nav";
import { renderless, api } from "@opentiny/vue-renderless/tabs-mf/vue-nav-item";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script$4 = defineComponent({
  props: _extends({}, $props, {
    title: String,
    name: String,
    selected: Boolean,
    navItem: Object
  }),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api,
      mono: true
    });
  },
  render: function render() {
    var state = this.state, handleNavItemClick = this.handleNavItemClick, selected = this.selected, title = this.title, handleNavItemClose = this.handleNavItemClose, navItem = this.navItem;
    var settingClick = function settingClick2(e) {
      return e.stopPropagation();
    };
    return h("div", {
      attrs: {
        "data-tag": "tiny-tab-nav-item"
      },
      class: ["w-max h-11 sm:h-10 inline-flex flex-col justify-center pl-3 pr-3 group", "first:ml-3 last:mr-3 hover:cursor-pointer sm:first:pl-0 sm:last:pr-0 sm:first:ml-0 sm:last:mr-0", state.tabSize === "big" ? "min-w-[theme(spacing.8)]" : "min-w-[theme(spacing.7)]"],
      on: {
        click: handleNavItemClick
      }
    }, [h("div", {
      class: ["inline-block text-base sm:text-sm group-hover:text-color-brand", selected ? "text-color-brand" : "text-color-text-primary sm:text-color-text-secondary"],
      style: state.tabSize === "big" ? "font-size: 1rem" : ""
    }, [h("span", {
      class: "w-max relative"
    }, [navItem.slotTitle ? navItem.slotTitle(navItem) : h("span", {}, title), selected ? h("div", {
      class: "absolute sm:-bottom-2.5 -bottom-3 w-full h-0.5 bg-color-brand z-20"
    }, []) : null]), navItem.slotSetting || state.withClose ? h("span", {
      class: ["pl-2 inline-flex translate-y-0.5 text-xs fill-color-icon-primary", "hover:fill-color-icon-hover focus:fill-color-icon-focus", navItem.slotSetting ? "-translate-y-0.5" : ""],
      on: {
        click: navItem.slotSetting ? settingClick : handleNavItemClose
      }
    }, [navItem.slotSetting ? navItem.slotSetting(navItem) : h(IconClose())]) : null])]);
  }
});
var __vue2_render$3, __vue2_staticRenderFns$3;
var __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(__vue2_script$4, __vue2_render$3, __vue2_staticRenderFns$3, false, __vue2_injectStyles$4, null, null, null);
function __vue2_injectStyles$4(context) {
  for (var o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var TabNavItem = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var __vue2_script$3 = defineComponent({
  props: _extends({}, $props, {
    customClass: {
      type: String,
      default: ""
    }
  }),
  setup: function setup2(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless: renderless$1,
      api: api$1,
      mono: true
    });
  },
  render: function render2() {
    var state = this.state, customClass = this.customClass;
    return h("div", {
      attrs: {
        "data-tag": "tiny-tab-nav"
      },
      class: customClass
    }, state.navItems.map(function(item) {
      return typeof item.visible === "undefined" || item.visible ? h(TabNavItem, {
        key: item.name,
        props: {
          title: item.title,
          name: item.name,
          selected: item.selected,
          navItem: item
        }
      }) : null;
    }));
  }
});
var __vue2_render$2, __vue2_staticRenderFns$2;
var __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(__vue2_script$3, __vue2_render$2, __vue2_staticRenderFns$2, false, __vue2_injectStyles$3, null, null, null);
function __vue2_injectStyles$3(context) {
  for (var o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var TabNav = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var __vue2_script$2 = defineComponent({
  props: [].concat(props),
  setup: function setup3(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless: renderless$2,
      api: api$2,
      mono: true
    });
  },
  render: function render3() {
    var state = this.state, handleClickDropdownItem = this.handleClickDropdownItem, key = this.key, emitAdd = this.emitAdd;
    var tabNavClass = state.moreList.length > 0 ? "w-max inline-block" : "w-full inline-flex justify-around sm:w-max sm:inline-block";
    return h("div", {
      attrs: {
        "data-tag": "tiny-tab-bar"
      },
      class: "w-full h-11 sm:h-10 overflow-hidden relative"
    }, [h("div", {
      ref: "scroll",
      class: ["scrollbar-size-0 w-full overflow-x-auto whitespace-nowrap", "before:block before:absolute before:w-0 before:h-11 sm:before:h-10", "after:block after:absolute after:top-0 after:right-0 after:w-0 after:h-11 sm:after:h-10", "before:shadow-[1px_-10px_4px_4px_rgba(0,0,0,0.08)] after:shadow-[-1px_-10_4px_4px_rgba(0,0,0,0.08)]", !state.moreLeft && !state.moreRight ? "before:hidden after:hidden" : "", !state.moreLeft ? "sm:before:hidden" : "", !state.moreRight ? "sm:after:hidden" : ""]
    }, [h(TabNav, {
      ref: "tabNav",
      props: {
        customClass: tabNavClass
      },
      style: "margin-right:" + state.navPaddingRight + "px"
    })]), h("div", {
      class: "invisible sm:visible absolute w-full h-px bottom-px bg-color-border-separator z-10"
    }), h("div", {
      ref: "tabMore",
      attrs: {
        "data-tag": "tiny-tab-more"
      },
      class: ["inline-flex w-max h-11 sm:h-10 absolute top-0 right-0 z-0 bg-color-bg-1", state.moreRight ? "shadow-[-1px_-10px_4px_4px_rgba(0,0,0,0.08)]" : ""]
    }, [state.moreList.length ? h("div", {
      class: "hidden sm:inline-block w-11 h-11 sm:h-10 text-sm cursor-pointer"
    }, [h("span", {
      class: "inline-flex w-full h-full flex-col justify-center items-center"
    }, [h(Dropdown, {
      on: {
        "item-click": handleClickDropdownItem
      },
      props: {
        showIcon: false
      }
    }, [h("span", {}, [h(IconPopup(), {
      class: "fill-color-icon-focus text-base"
    })]), h(DropdownMenu, {
      slot: "dropdown",
      props: {
        popperClass: "max-h-[theme(spacing.80)] overflow-x-hidden overflow-y-auto"
      }
    }, state.moreOptions.map(function(opt) {
      return h(DropdownItem, {
        key: key(opt),
        props: {
          itemData: opt.name
        }
      }, [opt.slotTitle ? opt.slotTitle() : opt.title]);
    }))])])]) : null, state.withAdd ? h("div", {
      attrs: {
        "data-tag": "tiny-tab-add"
      },
      class: "hidden sm:inline-block w-11 h-11 sm:h-10 text-sm cursor-pointer",
      on: {
        click: emitAdd
      }
    }, [h("span", {
      class: "inline-flex w-full h-full flex-col justify-center items-center"
    }, [h(IconPlus(), {
      class: "fill-color-icon-focus"
    })])]) : null, state.slotCustom ? h("div", {
      attrs: {
        "data-tag": "tiny-tab-custom"
      },
      class: "hidden sm:inline-block w-max h-11 sm:h-10 text-sm"
    }, [h("span", {
      class: "inline-flex w-max h-full flex-col justify-center"
    }, [state.slotCustom()])]) : null])]);
  }
});
var __vue2_render$1, __vue2_staticRenderFns$1;
var __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(__vue2_script$2, __vue2_render$1, __vue2_staticRenderFns$1, false, __vue2_injectStyles$2, null, null, null);
function __vue2_injectStyles$2(context) {
  for (var o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var TabBar = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var __vue2_script$1 = defineComponent({
  props: _extends({}, $props, {
    item: Object
  }),
  render: function render4() {
    var content = null;
    if (this.item) {
      if (typeof this.item.slotDefault === "function") {
        content = this.item.slotDefault();
      } else if (this.item.slotDefault) {
        content = this.item.slotDefault;
      }
    }
    return h("div", {
      attrs: {
        "data-tag": "tiny-tab-panel"
      }
    }, [content]);
  }
});
var __vue2_render, __vue2_staticRenderFns;
var __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(__vue2_script$1, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles$1, null, null, null);
function __vue2_injectStyles$1(context) {
  for (var o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var TabPanel = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var __vue2_script = defineComponent({
  props: [].concat(props, ["activeName", "modelValue", "size", "withClose", "withAdd", "beforeLeave"]),
  emits: ["update:activeName", "update:modelValue"],
  components: {
    TabBar,
    TabPanel
  },
  setup: function setup4(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless: renderless$3,
      api: api$3
    });
  }
});
var render5 = function render6() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    attrs: {
      "data-tag": "tiny-tabs"
    }
  }, [_c("div", {
    staticClass: "hidden"
  }, [_vm._t("default")], 2), _c("tab-bar", {
    ref: "tabbar"
  }), _c("keep-alive", [_vm._l(_vm.state.items, function(item) {
    return [item === _vm.state.currentItem ? [_c("tab-panel", {
      key: item.name,
      staticClass: "w-full",
      attrs: {
        "data-tag": "tiny-tab-panel",
        "item": item
      }
    })] : _vm._e()];
  })], 2)], 1);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render5, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
